import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { CategoriasProductoInterface } from "../../interfaces/categoriaInterfaces/CategoriasProducto.interface";
import { ProveedorInterface } from "../../interfaces/proveedorInterfaces/Proveedor.interface";

export async function ToggleVisibilityProveedorction(
  idCategoria: string
): Promise<ApiResponse<ProveedorInterface>> {
  const { data } = await apiClient.patch<ProveedorInterface>(
    `gpProveedoresProducto/${idCategoria}/toggleVisibility`
  );
  return {
    status: 200,
    data,
    message:
      "Proveedor de la categoría de producto actualizada correctamente",
  };
}
